import { __experimentalNumberControl as NumberControl } from '@wordpress/components';
import { devices } from '@helpers/utils.js';
import {
  MediaReplaceButton,
  MediaRemoveButton,
} from '@components/media-upload';

const {
  i18n: { __ },
  blockEditor: { MediaUpload, MediaUploadCheck },
  components: { ColorPalette, PanelBody, Button },
} = wp;

const ImageGradient = ({ imageGradientBackgroundOptions, setAttributes }) => {
  const colors = wp.data.select('core/block-editor').getSettings().colors;
  const changeBackgroundImage = (
    url,
    alt,
    paramDeviceType,
    paramImageAsBackgroundOptions,
  ) => {
    setAttributes({
      imageGradientBackgroundOptions: {
        ...paramImageAsBackgroundOptions,
        [paramDeviceType]: {
          ...imageGradientBackgroundOptions[paramDeviceType],
          settings: {
            ...paramImageAsBackgroundOptions[paramDeviceType].settings,
            url,
            alt,
          },
        },
      },
    });
  };

  const changeAttributeValue = (
    paramValue,
    paramDeviceType,
    paramGradientOptions,
    paramAttributeVariable,
  ) => {
    setAttributes({
      imageGradientBackgroundOptions: {
        ...paramGradientOptions,
        [paramDeviceType]: {
          ...imageGradientBackgroundOptions[paramDeviceType],
          settings: {
            ...paramGradientOptions[paramDeviceType].settings,
            [paramAttributeVariable]: paramValue,
          },
        },
      },
    });
  };

  return (
    <>
      {devices.map((device, index) => {
        const deviceType = device.type;
        const deviceLabel = device.label;
        const { url, alt } =
          imageGradientBackgroundOptions[deviceType].settings;
        return (
          <PanelBody
            title={deviceLabel}
            initialOpen={index === 0}
            key={deviceType}
          >
            <MediaUploadCheck>
              <MediaUpload
                allowedType={['image']}
                value={url}
                onSelect={(img) => {
                  const { url = '', alt = '' } = img;
                  changeBackgroundImage(
                    url,
                    alt,
                    deviceType,
                    imageGradientBackgroundOptions,
                  );
                }}
                render={({ open }) => (
                  <div className="media-upload image-upload">
                    {url && (
                      <div className="upload-buttons-wrapper">
                        <MediaReplaceButton onClick={open} />
                        <MediaRemoveButton
                          onClick={() => {
                            changeBackgroundImage(
                              '',
                              '',
                              deviceType,
                              imageGradientBackgroundOptions,
                            );
                          }}
                        />
                      </div>
                    )}
                    {!url && (
                      <Button
                        className="media-button upload-button"
                        onClick={open}
                      >
                        {__('Upload Image', 'b3rg')}
                      </Button>
                    )}
                    {url && (
                      <div
                        className="image-thumb-wrapper"
                        onClick={open}
                        onKeyUp={open}
                        role="button"
                        tabIndex="0"
                      >
                        <img className="image-thumb" src={url} alt={alt} />
                      </div>
                    )}
                  </div>
                )}
              ></MediaUpload>
            </MediaUploadCheck>
            <hr />
            <ColorPalette
              label={__('Select Background Color #1', 'b3rg')}
              colors={colors}
              enableAlpha
              value={
                imageGradientBackgroundOptions[deviceType]?.settings
                  .gradientColorOne
              }
              onChange={(newValue) =>
                changeAttributeValue(
                  newValue,
                  deviceType,
                  imageGradientBackgroundOptions,
                  'gradientColorOne',
                )
              }
            />
            <ColorPalette
              label={__('Select Background Color #2', 'b3rg')}
              colors={colors}
              enableAlpha
              value={
                imageGradientBackgroundOptions[deviceType]?.settings
                  .gradientColorTwo
              }
              onChange={(newValue) =>
                changeAttributeValue(
                  newValue,
                  deviceType,
                  imageGradientBackgroundOptions,
                  'gradientColorTwo',
                )
              }
            />
            <NumberControl
              label={__('Gradient Direction (Degrees)', 'b3rg')}
              step="any"
              min={0}
              max={360}
              value={
                imageGradientBackgroundOptions[deviceType]?.settings
                  .gradientDirection
              }
              onChange={(newValue) =>
                changeAttributeValue(
                  newValue,
                  deviceType,
                  imageGradientBackgroundOptions,
                  'gradientDirection',
                )
              }
            />
            <NumberControl
              label={__('Color 1 Location (%)', 'b3rg')}
              step="any"
              min={0}
              max={100}
              value={
                imageGradientBackgroundOptions[deviceType]?.settings
                  .gradientColorOneLocation
              }
              onChange={(newValue) =>
                changeAttributeValue(
                  newValue,
                  deviceType,
                  imageGradientBackgroundOptions,
                  'gradientColorOneLocation',
                )
              }
            />
            <NumberControl
              label={__('Color 2 Location (%)', 'b3rg')}
              step="any"
              min={0}
              max={100}
              value={
                imageGradientBackgroundOptions[deviceType]?.settings
                  .gradientColorTwoLocation
              }
              onChange={(newValue) =>
                changeAttributeValue(
                  newValue,
                  deviceType,
                  imageGradientBackgroundOptions,
                  'gradientColorTwoLocation',
                )
              }
            />
          </PanelBody>
        );
      })}
    </>
  );
};

export default ImageGradient;
